<template>
    <div class="d-flex">
        <schema-search-select
            v-if="field && field.dependsOn"
            class="flex-grow-1"
            v-bind="$attrs"
            :value="value"
            :label="field.title"
            :rules="rules"
            :required="required"
            :entity-key="field.dependsOn.entityKey"
            :scope="scope"
            search-when-blank
            v-on="$listeners" />

        <app-icon-button
            v-if="canAdd"
            class="ml-2"
            style="align-self: flex-start; margin-top: 2px;"
            icon="mdi-plus"
            @click="add" />

        <schema-form-dialog
            :entity-key="field.dependsOn.entityKey"
            :value="editedItem"
            :scope="scope"
            :fixed-values="fixedValues"
            @input="onItemSaved" />
    </div>
</template>

<script>
import formFieldMixin from "./formFieldMixin";
import { canAdd } from "@/features/schemas/services/schemaApi";

export default {
    types: ["entity"],
    mixins: [formFieldMixin],
    props: {
        value: {
            type: Number,
            default: null
        },
        fixedValues: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            editedItem: null
        };
    },
    computed: {
        canAdd() {
            return canAdd(this.field.dependsOn.entityKey, this.scope);
        }
    },
    methods: {
        add() {
            this.editedItem = {};
        },
        async onItemSaved(value) {
            this.editedItem = null;
            if (value) {
                this.$emit('input', value.id)
            }
        },
    }
}
</script>
